export interface IState {
  quickbookConnect: boolean;
  incomeAccountList: any;
  expenseAccountList: any;
  assetsAccountList: any;
  companyName: string;
  companyAddress: any;
  defaultAsset: any;
  defaultIncome: any;
  defaultExpense: any;
  lastSyncDate: any;
}

type Action = any;

export const quickBooksReducer = (
  state: IState = {
    incomeAccountList: [],
    expenseAccountList: [],
    assetsAccountList: [],
    quickbookConnect: false,
    companyName: "",
    companyAddress: null,
    defaultAsset: null,
    defaultIncome: null,
    defaultExpense: null,
    lastSyncDate: null,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_QUICKBOOKS_SETTING_LIST":
      return {
        ...state,
        companyName: action.payload?.company_name,
        companyAddress:
          Object.keys(action.payload?.company_address)?.length > 0 ? action.payload?.company_address : null,
        quickbookConnect: action.payload?.quickbook_connect,
        incomeAccountList: action.payload?.incomeList,
        expenseAccountList: action.payload?.expenseList,
        assetsAccountList: action.payload?.assetList,
        defaultAsset: action.payload?.defaultAsset,
        defaultIncome: action.payload?.defaultIncome,
        defaultExpense: action.payload?.defaultExpense,
      };

    case "GET_ONLY_STATUS":
      return {
        ...state,
        quickbookConnect: action.payload?.quickbook_connect,
      };

    case "GET_LAST_SYNC_DATE":
      return {
        ...state,
        lastSyncDate: action?.payload,
      };

    case "DISCONNECT_QUICKBOOK":
      return {
        ...state,
        companyName: null,
        companyAddress: null,
      };
    case "WHEN_CONNECT_XERO_QUICKBOOKS_CLEAR":
      return {
        ...state,
        companyName: "",
        companyAddress: null,
        quickbookConnect: false,
        incomeAccountList: [],
        expenseAccountList: [],
        assetsAccountList: [],
        defaultAsset: null,
        defaultIncome: null,
        defaultExpense: null,
        lastSyncDate: null,
      };
    default:
      return state;
  }
};
